<template>
  <div class="divider mt-lg mb-lg"></div>
</template>
